/*
  Happy Ganga - About chapter 02 timeline.

  1. Sizes the gradient line so it runs exactly from the first dot's centre to
     the last dot's centre, whatever the copy wraps to (Figma 529:2722).
  2. Arms the timeline, then lights it when it scrolls in: the line draws down
     and the dots pop in one after another (CSS does the timing).

  Without this script the timeline renders complete and static: the hidden
  pre-state only applies under .is-armed, which is set here.
*/
(() => {
  'use strict';

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function size(tl) {
    const dots = tl.querySelectorAll('.hg-ab-c2__dot');
    if (!dots.length) return;
    const box = tl.getBoundingClientRect();
    const a = dots[0].getBoundingClientRect();
    const b = dots[dots.length - 1].getBoundingClientRect();
    const top = a.top + a.height / 2 - box.top;
    const bottom = b.top + b.height / 2 - box.top;
    const left = a.left + a.width / 2 - box.left;
    tl.style.setProperty('--tl-top', top.toFixed(1) + 'px');
    tl.style.setProperty('--tl-h', Math.max(0, bottom - top).toFixed(1) + 'px');
    tl.style.setProperty('--tl-x', left.toFixed(1) + 'px');
  }

  function init(root) {
    root.querySelectorAll('[data-hg-ab-tl]:not([data-hg-ab-tl-ready])').forEach((tl) => {
      tl.dataset.hgAbTlReady = '1';
      size(tl);
      if ('ResizeObserver' in window) new ResizeObserver(() => size(tl)).observe(tl);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => size(tl));

      if (reduced() || !('IntersectionObserver' in window)) {
        tl.classList.add('is-on');
        return;
      }

      tl.classList.add('is-armed');
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            e.target.classList.add('is-on');
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px -8% 0px' }
      );
      io.observe(tl);
    });
  }

  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
